import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import type { CalendarEvent } from '../../../../../../store/calendar/calendar.models';

export type CalendarEventActionsDialogData = {
  event: CalendarEvent;
};

export type CalendarEventActionsDialogResult = 'join' | 'edit' | 'delete' | 'cancel';

@Component({
  selector: 'app-calendar-event-actions-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './calendar-event-actions-dialog.component.html',
  styleUrl: './calendar-event-actions-dialog.component.scss',
})
export class CalendarEventActionsDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<CalendarEventActionsDialogComponent, CalendarEventActionsDialogResult>);
  protected readonly data = inject<CalendarEventActionsDialogData>(MAT_DIALOG_DATA);

  protected close(): void {
    this.dialogRef.close('cancel');
  }

  protected select(action: Exclude<CalendarEventActionsDialogResult, 'cancel'>): void {
    this.dialogRef.close(action);
  }

  protected canJoin(): boolean {
    return this.data.event.event_type === 'online' || !!this.data.event.meeting_url?.trim();
  }

  protected formatEventTime(): string {
    const start = new Date(this.data.event.start_at);
    const end = new Date(this.data.event.end_at);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      return '';
    }

    const date = start.toLocaleDateString(undefined, {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    });
    const startTime = start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const endTime = end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return `${date} • ${startTime} - ${endTime}`;
  }
}
